// extracted by mini-css-extract-plugin
module.exports = {"list":"styles-module__list___3p4F5"};